function maAgeSolicitarSede(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};

  if (response.horariosFront) {
    if (response.evento) {
      const accionStore = 'setEvento';

      valor = response.evento;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.telefonoPaciente) {
      const accionStore = 'setTelefonoPaciente';
      valorCambiaPanelLateral = 0;
      valor = response.telefonoPaciente;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.nomb_paciente) {
      const accionStore = 'setNombrePaciente';
      valor = response.nomb_paciente;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.sede) {
      const accionStore = 'setSede';

      valor = response.sede;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.docId) {
      const accionStore = 'setOrdenId';

      valor = response.docId;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.nomb_prestacion) {
      const accionStore = 'setNombrePrestacion';

      valor = response.nomb_prestacion;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    if (response.cups) {
      const accionStore = 'setCups';

      valor = response.cups;
      jsonActionValor = {
        valor,
        accionStore,
      };
      matrizActionValor.push(jsonActionValor);
    }
    valorCambiaPanelLateral = 7;
  } else {
    valorCambiaPanelLateral = 0;
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maAgeInicio(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.telefonoPaciente && typeof response.telefonoPaciente === "number") {
    const accionStore = 'setTelefonoPaciente';
    valorCambiaPanelLateral = 0;
    valor = response.telefonoPaciente;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } else {
    matrizActionValor.push({
      accionStore: 'setTelefonoPaciente',
      valor: null
    });
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maAgeCita(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.match.fields) {
    const accionStore = 'setFechaHoraCita';
    valorCambiaPanelLateral = 7;
    valor = response.match.fields.fechaHoraCita.numberValue;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}


module.exports.agendamientoEstados = function agendamientoEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case 'ma_age_cancelar_agendar_citas_usuario_interno':
      case 'ma_age_pal_clave':
      case 'ma_age_new_suggs':
      case 'ma_age_solicitar_sede':
        resolve(maAgeSolicitarSede(response));
        break;
      case 'ma_age_inicio':
        resolve(maAgeInicio(response));
        break;
      case 'ma_age_cita':
        resolve(maAgeCita(response));
        break;
      default:
        reject('Error');
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/modulosChatBox/agendamiento.js